"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LogoWithText;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function LogoWithText(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        viewBox: "0 0 105 24",
        width: "105",
        height: "24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !!title
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9266 2.77812C11.1535 1.85664 9.77994 1.73645 8.85862 2.50966L6.72414 4.30102C7.42905 4.53734 8.07972 4.96482 8.5926 5.57616L10.8594 8.27813L14.1934 5.48009L11.9266 2.77812ZM2.70749 5.06119L7.57328 0.977574C9.34059 -0.505639 11.9754 -0.275078 13.4584 1.49255L16.3679 4.96056C16.5383 5.16373 16.6211 5.4263 16.598 5.6905C16.5749 5.95471 16.4478 6.19891 16.2447 6.36939L14.304 7.99804L17.0226 11.2385C18.5055 13.0061 18.275 15.6414 16.5077 17.1246L9.48201 23.021C9.48143 23.0214 9.48084 23.0219 9.48026 23.0224C7.71295 24.5056 5.0781 24.2751 3.59515 22.5075L0.233916 18.501C0.063469 18.2978 -0.0193037 18.0352 0.0038073 17.771C0.0269183 17.5068 0.15402 17.2626 0.357151 17.0922L4.45943 13.6493L2.19261 10.9473C0.709658 9.17973 0.940178 6.5444 2.70749 5.06119ZM5.74477 15.1814L2.4084 17.9815L5.12696 21.2219C5.90003 22.1434 7.2736 22.2636 8.19492 21.4903C9.11623 20.7171 9.2364 19.3433 8.46333 18.4218L5.74477 15.1814ZM10.9262 19.1981C10.816 18.4627 10.508 17.7476 9.99514 17.1363L3.72442 9.66178C2.95135 8.7403 3.07152 7.36648 3.99283 6.59327C4.91414 5.82006 6.28771 5.94026 7.06079 6.86173L9.97028 10.3297C10.1407 10.5329 10.3849 10.66 10.649 10.6832C10.9132 10.7063 11.1757 10.6235 11.3789 10.453L12.7722 9.28362L15.4908 12.524C16.2639 13.4455 16.1437 14.8193 15.2224 15.5926L10.9262 19.1981Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M28.5539 20.2847C28.0356 20.2847 27.6408 20.5066 27.4686 20.9255H27V15.5476H27.6664C28.3817 17.8665 30.3554 19.6431 32.6006 19.6431C34.4757 19.6431 35.7092 18.5295 35.7092 17.003C35.7092 15.2272 34.4757 13.771 32.3042 12.3901L29.6367 10.712C27.8609 9.59841 27.0711 8.46767 27.0711 6.86408C27.0711 4.5692 29.2915 3.04014 32.6468 3.04014C34.2744 3.04014 35.0145 3.43418 35.7795 3.43418C36.1221 3.43418 36.4211 3.31168 36.4708 3.0153H36.8408L38.3742 7.75154H37.6092C36.8691 5.65454 35.1182 4.39702 32.873 4.39702C30.9978 4.39702 29.9373 5.08745 29.9373 6.22247C29.9373 6.96259 30.3322 7.62818 31.8365 8.54134L34.9477 10.4165C37.4841 11.943 38.7168 13.6725 38.7168 16.0659C38.7168 19.0752 36.398 21 32.9441 21C30.7246 21 29.5159 20.2847 28.5539 20.2847Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M40.0259 14.4871C40.0259 10.6135 42.8382 8.04794 46.7606 8.04794C49.8941 8.04794 51.8429 9.60185 51.8429 11.3031C51.8429 12.0432 51.275 12.5375 50.5109 12.5375C48.0438 12.5375 49.2259 9.3303 46.7606 9.3303C44.6884 9.3303 43.1097 11.4025 43.1097 14.4863C43.1097 17.4707 44.7373 19.4692 47.2052 19.4692C49.2525 19.4692 50.7327 18.2109 51.2013 16.065H51.9166C51.7196 18.9775 49.4992 20.9246 46.3657 20.9246C42.5666 20.9255 40.0259 18.3599 40.0259 14.4871Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M61.7847 9.89823C61.7847 10.8354 61.2707 11.5018 60.379 11.5018C59.4367 11.5018 59.1703 10.4902 58.4541 10.4902C57.4922 10.4902 56.8506 11.7751 56.8506 13.9689V18.509C56.8506 19.7673 57.2703 19.9892 58.4781 20.0389V20.6556H53.126V20.0389C53.5945 19.9892 54.0134 19.7673 54.0134 19.0024V10.9347C54.0134 10.2186 53.5945 10.1201 53.126 10.1201V9.50333L56.1104 8.07278H56.7058L56.8043 10.688C57.3183 9.00992 58.4079 8.02309 59.8136 8.02309C60.9957 8.02309 61.7847 8.81289 61.7847 9.89823Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M67.6561 20.038V20.6548H63.0449V20.038C63.5135 19.9883 63.9332 19.7665 63.9332 19.0015V10.9347C63.9332 10.2186 63.5135 10.1201 63.0449 10.1201V9.50333L66.1776 8.07278H66.7704V19.0015C66.7686 19.7665 67.1875 19.9883 67.6561 20.038ZM63.5118 5.07044C63.5118 4.70449 63.6203 4.34675 63.8236 4.04247C64.0269 3.73819 64.3159 3.50104 64.654 3.36099C64.9921 3.22095 65.3641 3.18431 65.7231 3.2557C66.082 3.3271 66.4117 3.50332 66.6704 3.76209C66.9292 4.02085 67.1054 4.35055 67.1768 4.70947C67.2482 5.06839 67.2116 5.44042 67.0715 5.77852C66.9315 6.11662 66.6943 6.40559 66.39 6.60891C66.0858 6.81222 65.728 6.92074 65.3621 6.92074C65.1184 6.92314 64.8767 6.87692 64.6512 6.78479C64.4256 6.69265 64.2207 6.55645 64.0484 6.38416C63.8761 6.21186 63.7399 6.00693 63.6477 5.78136C63.5556 5.55578 63.5094 5.3141 63.5118 5.07044Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M82.0882 14.4871C82.0882 18.3599 79.6948 20.9255 76.0919 20.9255C74.4386 20.9255 73.0569 20.1854 72.3416 19.0015C71.4284 19.1728 70.7877 19.9635 70.5898 20.9255H69.776V5.87717C69.776 5.16104 69.3563 5.06199 68.8877 5.06199V4.44565L72.0212 3.01508H72.6131V10.1946C73.2787 8.83774 74.735 8.04794 76.4859 8.04794C79.843 8.04794 82.0882 10.6135 82.0882 14.4871ZM79.0044 14.4871C79.0044 11.5746 77.6475 9.65153 75.6002 9.65153C73.8013 9.65153 72.6148 11.2054 72.6148 13.5243V15.7695C72.6148 17.941 73.7987 19.3964 75.6002 19.3964C77.6475 19.3956 79.0044 17.4253 79.0044 14.4871Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M94.6701 16.2629H95.3854C95.2141 19.0512 92.9432 20.9255 89.7112 20.9255C85.9857 20.9255 83.5195 18.3556 83.5195 14.4871C83.5195 10.6186 86.0354 8.04794 89.8345 8.04794C93.2387 8.04794 95.5087 10.4165 95.5087 13.9937H86.6016V14.4871C86.6016 17.4964 88.2292 19.4949 90.6483 19.4949C92.6468 19.4949 94.1519 18.2862 94.6701 16.2629ZM86.7267 12.8587H92.3016C92.2279 10.7369 91.2411 9.33115 89.7857 9.33115C88.2558 9.33115 87.0959 10.688 86.7267 12.8587V12.8587Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M104.995 9.89823C104.995 10.8354 104.477 11.5018 103.589 11.5018C102.652 11.5018 102.38 10.4902 101.665 10.4902C100.703 10.4902 100.061 11.7751 100.061 13.9689V18.509C100.061 19.7673 100.48 19.9892 101.689 20.0389V20.6556H96.3359V20.0389C96.8045 19.9892 97.2242 19.7673 97.2242 19.0024V10.9347C97.2242 10.2186 96.8045 10.1201 96.3359 10.1201V9.50333L99.3212 8.07278H99.9132L100.012 10.688C100.526 9.00992 101.615 8.02309 103.022 8.02309C104.206 8.02309 104.995 8.81289 104.995 9.89823Z"
    }));
}

//# sourceMappingURL=LogoWithText.js.map